<h1>Management</h1>
<div class="management">
    <div class="actions">
        <div class="resync-action">
            <h4>Resync PIM Data</h4>
            <button type="button" mat-raised-button color="primary" (click)="resyncPim()">Run</button>
        </div>
        <div class="resync-action">
            <h4>Resync Identity Data</h4>
            <button type="button" mat-raised-button color="primary" (click)="resyncIdentity()">Run</button>
        </div>
        <div class="resync-action">
            <h4>Catch Up Dead Letters</h4>
            <button type="button" mat-raised-button color="primary" [disabled]="catchUpInProgress" (click)="onCatchUp()">Run</button>
        </div>
    </div>
    <background-task-list [tasks]="tasks" (refreshTasks)="loadTaskList()"></background-task-list>
</div>
